import React from 'react';

import { useCurrentUser } from '~/src/common/user';
import { useLocale } from '~/src/components/LocaleProvider';

import { SnackbarForm } from './SnackbarForm';

export const PromoteBookSnackbar: React.FC = () => {
  const { currentUser } = useCurrentUser();
  const { locale } = useLocale();
  const isEnglishArticle = locale === 'en';

  if (currentUser || !isEnglishArticle) {
    return null;
  }

  return <SnackbarForm />;
};
